class BlogListing extends HTMLElement {
  constructor() {
    super();
    this.results = null;
    this.tabs = null;
    this.pagination = null;
    this.controller = null;
    this.onClick = this.onClick.bind(this);
    this.onPopState = this.onPopState.bind(this);
  }

  connectedCallback() {
    if (this.dataset.blogInit === "true") return;
    this.dataset.blogInit = "true";

    this.results = this.querySelector("[data-blog-results]");
    this.tabs = this.querySelector("[data-blog-tabs]");
    this.pagination = this.querySelector("[data-blog-pagination]");

    if (!this.results) return;

    this.addEventListener("click", this.onClick);
    window.addEventListener("popstate", this.onPopState);
    this.scrollActiveTabIntoView();
  }

  disconnectedCallback() {
    this.removeEventListener("click", this.onClick);
    window.removeEventListener("popstate", this.onPopState);
    if (this.controller) {
      this.controller.abort();
      this.controller = null;
    }
  }

  onPopState() {
    this.load(location.href, { push: false });
  }

  onClick(event) {
    const link = event.target.closest("a");
    if (!link) return;
    if (!link.href) return;
    if (!link.closest("[data-blog-tabs]") && !link.closest("[data-blog-pagination]")) {
      return;
    }
    if (!this.shouldHandleLink(event, link)) return;

    event.preventDefault();
    this.load(link.href, { push: true });
  }

  shouldHandleLink(event, link) {
    if (event.defaultPrevented) return false;
    if (event.button !== 0) return false;
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) {
      return false;
    }
    if (link.target && link.target !== "_self") return false;
    if (link.hasAttribute("download")) return false;
    if (link.origin !== location.origin) return false;
    return true;
  }

  setLoading(isLoading) {
    if (!this.results) return;
    this.results.classList.toggle("opacity-60", isLoading);
    this.results.classList.toggle("pointer-events-none", isLoading);
    this.results.setAttribute("aria-busy", isLoading ? "true" : "false");
    this.dataset.loading = isLoading ? "true" : "false";
  }

  async load(url, { push }) {
    if (!this.results) return;
    if (this.controller) {
      this.controller.abort();
    }
    this.controller = new AbortController();
    this.setLoading(true);

    try {
      const doc = await webvista.fetchHtml(url, this.controller.signal);
      const sourceResults = doc.querySelector("[data-blog-results]");
      if (!sourceResults) return;

      this.results.innerHTML = sourceResults.innerHTML;
      this.pagination = this.querySelector("[data-blog-pagination]");

      const sourceTabs = doc.querySelector("[data-blog-tabs]");
      if (sourceTabs && this.tabs) {
        this.tabs.innerHTML = sourceTabs.innerHTML;
        this.scrollActiveTabIntoView();
      }

      if (typeof webvista?.initLazyImageAnimation === "function") {
        webvista.initLazyImageAnimation(this.results);
      }

      this.scrollToTop();

      if (push) {
        history.pushState({ url }, "", url);
      }
    } catch (error) {
      if (error.name === "AbortError") return;
      console.error(error);
    } finally {
      if (this.controller) {
        this.controller = null;
      }
      this.setLoading(false);
    }
  }

  scrollActiveTabIntoView() {
    if (!this.tabs) return;
    const active = this.tabs.querySelector("[data-blog-tab-active]");
    if (!active) return;
    const container = this.tabs;
    const scrollLeft =
      active.offsetLeft - container.offsetWidth / 2 + active.offsetWidth / 2;
    container.scrollTo({ left: Math.max(0, scrollLeft), behavior: "smooth" });
  }

  scrollToTop() {
    const target = this.querySelector("[data-blog-list]") || this;
    const offset = window.innerHeight * 0.4;
    const targetTop =
      target.getBoundingClientRect().top + window.scrollY - offset;
    window.scrollTo({ top: Math.max(0, targetTop), behavior: "smooth" });
  }
}

customElements.define("blog-listing", BlogListing);
